module.exports = __webpack_public_path__ + "media/application/images/kids/main_background-fc9491d8684b9f305bacf4aa2a3b1038.png";